import React from "react";
import "./App.scss";
import { Routes, Route } from "react-router-dom";
import Main from "./components/main/Main";
import WorkDetails from "./components/home/works/workDetails/WorkDetails";
import NavBar from "./components/navBar/NavBar";
import PageNotFound from "./components/pageNotFound/PageNotFound";

function App() {
  return (
    <>
      <div className="bg-particle particle1"></div>
      <div className="bg-particle particle2"></div>
      <div className="appMainDiv">
        <div>
          <NavBar />
          <Routes>
            <Route path="/" element={<Main />} />
            <Route path="/project/:id" element={<WorkDetails />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </div>
      </div>
    </>
  );
}

export default App;
